module.exports = __webpack_public_path__ + "img/wind_300.c00b84b9.jpg";